module.exports = __webpack_public_path__ + "static/media/shibui_logo.5e53619c.svg";